module.exports = __webpack_public_path__ + "static/media/Hamburger_Spreadsheet.ac4f5b54.svg";